// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

import {
  QuestionWithAnswer,
} from "./types";

export default {
  id: __t.string(),
  underwritableEntity: __t.uuid(),
  get question() {
    return QuestionWithAnswer;
  },
  deletedAt: __t.option(__t.timestamp()),
};
